import * as types from "../types";

export default {
  [types.GET_CRM_ROLE](state, data) {
    state.crmRoles = data;
  },
  [types.GET_CRM_OPERATION_MENU](state, data) {
    state.operationMenu = data;
  },
  [types.GET_CRM_DATA_MENU](state, data) {
    state.dataMenu = data;
  },

  // 修改登录状态
  [types.AUTHENTICATED](state, data) {
    state.authenticated = data;
  },

  // 修改用户信息
  [types.GET_USERINFO](state, data) {
    state.userInfo = {
      userName: data.crmUserName,
      teamName: data.twoLevelTeamName,
      userUid: data.crmUserUid,
      categoryTeamType: data.categoryTeamType,
      teamId: Number(data.teamId),
      loginId: data.loginId,
    };
  },

  // // 存储后端返回的原始权限信息
  // [types.GET_AUTHORITY](state, data) {
  //   state.authority = data;
  // },

  // 修改权限信息
  [types.GET_AUTHORITY](state, data) {
    state.authority = data;
  },

  // 修改权限信息
  [types.GET_CRM_TEAM_LIST](state, data) {
    state.backTeamList = data;
  },
  // 客户相关权限
  [types.GET_CUSTOM_AUTH](state, data) {
    state.customAuth = data;
  },
  // 医生客户相关权限
  [types.GET_MEDICALCUSTOM_AUTH](state, data) {
    state.medicalCustomAuth = data;
  },
  // 产品线管理
  [types.GET_PRODUCT_MANAGE_AUTH](state, data) {
    state.productManageAuth = data;
  },
  // 拜访
  [types.GET_VISIT_AUTH](state, data) {
    state.visitAuth = data;
  },
  // 全局相关权限(快捷新增)
  [types.GET_QUICK_ADD_AUTH](state, data) {
    state.quickAuth = data;
  },
  // 合同权限(快捷新增)
  [types.GET_CONTRACT_AUTH](state, data) {
    state.contractAuth = data;
  },
  // 商机相关权限
  [types.GET_BUSINESS_AUTH](state, data) {
    state.businessAuth = data;
  },
};
